
import {defineComponent} from 'vue';
import axios from 'axios';

const configuration = require('../../config/' + process.env.VUE_APP_ENVIRONMENT + '/project.yaml');/* eslint @typescript-eslint/no-var-requires: "off" */
const api: any = configuration[process.env.VUE_APP_ENVIRONMENT].api
const authTokenName = 'authtoken_' + process.env.VUE_APP_ENVIRONMENT

export default defineComponent({
    name: 'Api',
    props: {
        data: {
            type: Object
        }
    },
    emits: ['update:data'],
    render() {
        return '';
    },
    data() {
        return {
            token: {
                access_token: '',
                expires_in: 0,
                token_type: ''
            }
        }
    },
    created() {
        this.getLocal()
        if (!this.validToken()) {
            this.getToken()
        }


    },
    watch: {
        token(val) {
            if (this.validToken()) {
                this.getCategories()
                this.refreshToken()
                let json = JSON.stringify(val)
                localStorage.setItem(authTokenName, json)
            }
        }
    },
    methods: {
        validToken() {
            return !!(this.token.access_token && this.token.token_type)
        },
        getLocal() {
            let item = localStorage.getItem(authTokenName)
            this.token = JSON.parse(item || '{}')
        },
        refreshToken() {
            let dateExpire = new Date(this.token['expires_in'])
            let timer = setInterval(() => {
                let timeNow = new Date()

                if (timeNow.getTime() > dateExpire.getTime()) {
                    clearInterval(timer)
                    this.getToken()
                    console.log('token Refresh')
                }

            }, 1000 * 10)
        },
        getToken() {
            let url = api.url + api.base_path + '/oauth/access-token'
            axios.post(url, {
                'grant_type': 'client_credentials',
                'scope': '*',
                'client_id': api.oauth_client_id,
                'client_secret': api.oauth_client_secret
            }).then((res) => {
                let now = new Date()
                res.data.expires_in = now.setSeconds(now.getSeconds() + res.data.expires_in)
                console.log(now)
                this.token = JSON.parse(JSON.stringify(res.data))
            }).catch((error) => {
                console.error(error)
            })
        },
        getCategories() {
            if (this.validToken()) {
                let url = api.url + api.base_path + '/categories?seo_available=true&is_principal=true'
                let header = this.token['token_type'] + ' ' + this.token['access_token']
                axios.get(url, {
                    headers: {
                        'Authorization': `${header}`
                    }
                }).then((res) => {
                    let data = res.data
                    if (typeof data.data.categories != 'undefined')
                        this.$emit('update:data', data.data.categories)

                }).catch((error) => {
                    console.error(error)
                })
            }
        }
    }
})
